import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  modalTitle: {
    description: 'Title for the connect freight provider modal',
    defaultMessage: 'Connect a Freight Provider',
    id: 'MuI5Ro',
  },
  notificationTitle: {
    description: 'Freight provider added success notification title',
    defaultMessage: 'Freight Provider Added',
    id: 'F18lb5',
  },
  notificationBody: {
    description: 'Freight provider added success notification content',
    defaultMessage: "You've successfully added a new freight provider to your account.",
    id: 'vi1YXg',
  },
  connectionFailedTitle: {
    description: 'Freight provider connection failure notification title',
    defaultMessage: 'Provider Connection Failed',
    id: 'UztFAI',
  },
});
